import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";
import React from "react";
import * as myConstClass from "../../../config/messageconstant";
import { ButtonCompo } from "../../../components/Comman/Button";
import { ChipCompo } from "../../../components/Comman/IconButton";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import RTTable from "../../../components/Comman/RT/RTTable";
import BootstrapDialogTitle from "./BootstrapDialogTitle";
import { NEGATIVE_PRODUCT_LIST_COLUMNS } from "../constants/advanceOutletInvoicingTableColumns";
import {
  orderListInfoChipSx,
  orderListWarningTitleSx,
} from "../styles/advanceOutletInvoicingStyles";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: 0,
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const NegativeProductListDialog = ({
  open,
  isLostOrder,
  isLostOrderFlag,
  filteredStockProductData,
  onClose,
  onSearch,
  onSaveBill,
}) => {
  const isConfirmMode = isLostOrder && isLostOrderFlag;
  const hasNegativeProducts = filteredStockProductData.length > 0;

  return (
		<BootstrapDialog
			className="order-list-dialog"
			onClose={onClose}
			aria-labelledby="customized-dialog-title"
			open={open}
			fullWidth
			maxWidth="xl"
		>
			<BootstrapDialogTitle id="customized-dialog-title" onClose={onClose}>
				<Box className="order-list-dialog-header">
					<Box className="order-list-dialog-icon order-list-dialog-icon--warning">
						{isConfirmMode ? (
							<WarningAmberRoundedIcon fontSize="small" />
						) : (
							<ProductionQuantityLimitsIcon fontSize="small" />
						)}
					</Box>
					<Box>
						<TypographyCompo className="order-list-dialog-title-text">
							{isConfirmMode
								? myConstClass.confirmOutOfStockOrdersTitleMsg
								: myConstClass.negativeProductListTitleMsg}
						</TypographyCompo>
						<TypographyCompo className="order-list-dialog-subtitle">
							{isConfirmMode
								? myConstClass.confirmOutOfStockOrdersSubtitleMsg
								: myConstClass.negativeProductListSubtitleMsg}
						</TypographyCompo>
					</Box>
					<ChipCompo
						size="small"
						label={`${filteredStockProductData.length} ${myConstClass.negativeProductListItemsLabelMsg}`}
						sx={orderListInfoChipSx}
					/>
				</Box>
			</BootstrapDialogTitle>

			<DialogContent dividers>
				<Box className="order-list-dialog-search">
					<LandingScreenHeader
						screenTitle=""
						showSearchBox={true}
						showTable={true}
						showFilter={false}
						showPdfDownload={false}
						showExcelDownload={false}
						onSearch={onSearch}
						searchPlaceholder={
							myConstClass.negativeProductListSearchPlaceholderMsg
						}
					/>
				</Box>

				<Box
					className={`order-list-modal-table${
						!hasNegativeProducts ? " order-list-modal-table--empty" : ""
					}`}
				>
					<RTTable
						showPegination={false}
						columns={NEGATIVE_PRODUCT_LIST_COLUMNS}
						tableData={filteredStockProductData}
						isActionColActive={false}
						emptyMessage={myConstClass.noNegativeProductFoundMsg}
						enhancedEmptyLayout
					/>
				</Box>

				{isConfirmMode && hasNegativeProducts && (
					<Box className="order-list-warning-panel">
						<TypographyCompo sx={orderListWarningTitleSx}>
							{myConstClass.confirmBeforeProceedingMsg}
						</TypographyCompo>
						<TypographyCompo className="order-list-warning-item">
							{myConstClass.closedOrderWarningInGujrati}
						</TypographyCompo>
						<TypographyCompo className="order-list-warning-item">
							{myConstClass.closedOrderWarningInHindi}
						</TypographyCompo>
						<TypographyCompo className="order-list-warning-item">
							{myConstClass.closedOrderWarning}
						</TypographyCompo>
					</Box>
				)}

				{isConfirmMode && (
					<Box className="order-list-dialog-footer">
						<ButtonCompo
							size="medium"
							type="button"
							variant="contained"
							name={
								hasNegativeProducts
									? myConstClass.lostAndProceedBtnMsg
									: myConstClass.proceedForBillingBtnMsg
							}
							onClick={onSaveBill}
						/>
					</Box>
				)}
			</DialogContent>
		</BootstrapDialog>
	);
};

export default NegativeProductListDialog;
